import { Component } from '@angular/core';
import { NavigationService } from '../navigation/navigation.service';

@Component({
  selector: 'ma-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
  constructor(private navigationService: NavigationService) {

  }


  hideHamburgerMenu(): void {
    this.navigationService.hideHamburgerMenu();
  }
}
